import { useSelector } from 'react-redux';
import { TcsmStates } from '../../../../../root/tcsm-model';

export function useGroupId(){
	return useSelector<TcsmStates, string>(state => state.groupsState?.currentGroup?.client_number);
}


export function useGroupFourDigitId() {
	return useSelector<TcsmStates, number>(state => state.groupsState?.currentGroup?.group_id);
}

export function useBillingAccountNumber() {
	return useSelector<TcsmStates, string>(state => state.billingAccountsState?.currentBillingAccount?.account_number);

}

export function useBillingClientNumber() {
	return useSelector<TcsmStates, string>(state => state.billingAccountsState?.currentBillingAccount?.account_owner_client_number);

}


export function useBillingAccountOwnerClientNumber() {
	return useSelector<TcsmStates, string>(state => state.billingAccountsState?.currentBillingAccount?.account_owner_client_number);

}